import apiClient from './client';

export const monitoredActivitiesKidApi = {
  list: () => apiClient.get('/monitored_activities'),
  listSessions: (status = 'completed') =>
    apiClient.get('/monitored_activity_sessions', { params: { status } }),
  createSession: (activityId) =>
    apiClient.post(`/monitored_activities/${activityId}/monitored_activity_sessions`),
  showSession: (sessionId) =>
    apiClient.get(`/monitored_activity_sessions/${sessionId}`),
  pause: (sessionId) =>
    apiClient.post(`/monitored_activity_sessions/${sessionId}/pause`),
  resume: (sessionId) =>
    apiClient.post(`/monitored_activity_sessions/${sessionId}/resume`),
  cancel: (sessionId) =>
    apiClient.post(`/monitored_activity_sessions/${sessionId}/cancel`),
  complete: (sessionId) =>
    apiClient.post(`/monitored_activity_sessions/${sessionId}/complete`),
  uploadClip: (sessionId, clipIndex, blob) => {
    const form = new FormData();
    form.append('clip_index', String(clipIndex));
    form.append('clip', blob, `clip-${clipIndex}.webm`);
    return apiClient.post(
      `/monitored_activity_sessions/${sessionId}/upload_clip`,
      form,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  },
};
